import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import { AppComponent } from './app.component';
import { WelcomeComponent } from './home/welcome.component';
import { RouterModule } from '@angular/router';
import { FileTransferModule } from './file_transfer/file_transfer.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { UploadModalComponent } from './upload-modal/upload-modal.component';

import { SuccessModalComponent } from './success-modal/success-modal.component';
import { UploadFileComponent } from './upload-file/upload-file.component';
import {
  NgbModalModule,
  NgbModule,
  NgbNavContent,
  NgbNavItem,
  NgbNavLink,
  NgbNavModule
} from '@ng-bootstrap/ng-bootstrap';
import 'rxjs' ;
import { DataSharingService } from './data-sharing.service';
import { GetDataService } from './users-management/get-data.service';
import { DeleteModalComponent } from './delete-modal/delete-modal.component';
import { AuthInterceptor } from './intercept';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {CommonModule} from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    ErrorModalComponent,
    UploadModalComponent,
    SuccessModalComponent,
    UploadFileComponent,
    DeleteModalComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbNavModule,
    NgbModalModule,
    RouterModule.forRoot([
      {path: 'upload', component: UploadFileComponent },
      { path: '', redirectTo: 'upload', pathMatch: 'full' },
      { path: '**', redirectTo: 'upload', pathMatch: 'full' }
    ]),
    FileTransferModule
  ],
  providers: [
    DataSharingService,
    GetDataService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    NgbNavLink, NgbNavContent, NgbNavItem
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
